"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Errors {
    constructor() {
        this._errors = [];
    }
    static single(error) {
        const impl = new ErrorsImpl();
        impl.addError(error);
        return impl;
    }
    get errors() {
        return this._errors;
    }
    get hasErrors() {
        return this._errors.length > 0;
    }
    toString() {
        return this.errors.map(e => e.message).join("\n");
    }
}
exports.Errors = Errors;
class ErrorsImpl extends Errors {
    addError(err) {
        this._errors.push(err);
    }
    addFrom(errors) {
        this._errors.push(...errors.errors);
    }
}
exports.ErrorsImpl = ErrorsImpl;
//# sourceMappingURL=errors.js.map